import { Component, computed, input } from '@angular/core';
import { ButtonComponent } from '../../../../../../shared/components/button/button.component';
import { MmrService } from '../../../../services/mmr.service';
import { ClaimDetailsPanelResumeBooking } from '../../../../types/mmr-claims.type';

@Component({
  selector: 'app-resume-booking',
  imports: [ButtonComponent],
  templateUrl: './resume-booking.component.html',
  styleUrl: './resume-booking.component.scss',
})
export class ResumeBookingComponent {
  claimType = input.required<'repair' | 'service'>();

  protected viewModel = computed(() => {
    const { claims } = this.mmrService.planClaimsDetails;
    const claimValue = claims.value()?.[this.claimType()] as ClaimDetailsPanelResumeBooking;

    return {
      claimId: claimValue.id,
      claimType: this.claimType(),
      claimValue,
      manufacturer: claims.value()?.itemDetails?.manufacturer,
      planNumber: this.mmrService.planNumber(),
      rms: claims.value()?.planOverview?.repairSystem,
    };
  });

  get vm() {
    return this.viewModel();
  }
  constructor(private readonly mmrService: MmrService) {}

  cancelBooking(): void {
    this.mmrService.performClaimCancel(this.vm.claimId, this.vm.rms);
  }

  continueBooking(): void {
    this.mmrService.navigateToOrbitResume(this.claimType(), this.vm.claimValue);
  }
}
